import React from 'react';

import { styled, useMediaQuery, useTheme } from '@mui/material';

import { MobileSlider } from '../mobile-slider/mobile-slider';
import { LabeledIcon, LabeledIconData } from './labeled-icon';

type IconGridProps = {
  icons: LabeledIconData[];
  className?: string;
  narrow?: boolean;
};

export const IconGrid = ({
  icons,
  className,
  narrow = false,
}: IconGridProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return isMobile ? (
    <MobileSlider>
      {icons.map((icon, idx) => (
        <LabeledIcon {...icon} key={idx} />
      ))}
    </MobileSlider>
  ) : (
    <Container className={className} narrow={narrow}>
      {icons.map((icon, idx) => (
        <LabeledIcon {...icon} key={idx} />
      ))}
    </Container>
  );
};

export default IconGrid;

const Container = styled('div')(
  ({ narrow }: { narrow: boolean }) =>
    ({ theme }) => ({
      display: 'grid',
      gridTemplateColumns: `repeat(1, minmax(auto, 320px))`,
      margin: '0 auto',
      rowGap: '25px',
      columnGap: 'var(--gutter)',

      [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
      },

      [theme.breakpoints.up('sm')]: {
        gridTemplateColumns: `repeat(${narrow ? 2 : 3}, 1fr)`,
        rowGap: '40px',
      },

      [theme.breakpoints.up('md')]: {
        gridTemplateColumns: `repeat(3, 1fr)`,
        width: narrow ? '100%' : '83.33334%',
        rowGap: '50px',
      },

      [theme.breakpoints.up('lg')]: {
        rowGap: '60px',
      },
    }),
);
